import { render, staticRenderFns } from "./padlet_list.vue?vue&type=template&id=1b3bd049&scoped=true&"
import script from "./padlet_list.vue?vue&type=script&lang=js&"
export * from "./padlet_list.vue?vue&type=script&lang=js&"
import style0 from "./padlet_list.vue?vue&type=style&index=0&id=1b3bd049&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3bd049",
  null
  
)

export default component.exports